<template>
  <div class="wrapper">
    <b-container >
    <!-- <b-container style="padding-left:23px;padding-right:23px;"> -->
      <b-row>
        <!-- 左侧 -->
        <b-col cols md="8" style="margin-top: 3rem">
          <slot name="video"></slot>
          <div class="title">
            <div class="topTxt">{{ mainTit.topTxt }}</div>
            <div class="lowTxt">
              <span>{{ mainTit.lowTxt }}</span>
              <span style=" font-size: 1rem;    margin-left: 2rem;">{{ mainTit.date.slice(0,10).replace(/-/g, ".") }}</span>
            </div>
          </div>
          <div v-if="newInfo" class="content" v-html="newInfo"></div>
          <slot name="tabs"></slot>
          <Share></Share>
        </b-col>
        <!-- 右侧 -->
        <b-col cols md="4">
          <slot name="right-related"></slot>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Share from "@/components/share";

export default {
  components: {
    Share,
  },
  props: {
    article: {
      type: String,
    },
    mainTit: {
      type: Object,
      default: () => {
        return {
          topTxt: "2018未来科学大奖科学峰会精彩瞬间",
          lowTxt: "未来科学大奖科学峰会",
          date: "2018.11.18",
        };
      },
    },
    newInfo: {
      type: String,
    },
  },
  watch: {
    article: {
      handler(val) {},
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      // newInfo: "",
      show: true,
    };
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.wrapper::v-deep {
  margin: auto;

  .nav {
    border-left: 0.1rem solid #ebebeb;
  }

  .nav-item {
    width: 8rem;
    border-bottom: 0.1rem solid #ebebeb;
    border-top: 0.1rem solid #ebebeb;
    text-align: center;
    border-right: 0.1rem solid #ebebeb;
  }

  a {
    color: #666666;
  }

  .nav-pills .nav-link.active {
    color: #fff;
    background-color: #0092de;
    border-radius: 0 !important;
  }
}

.tab-active {
  background-color: #980202;
}

.time-info {
  font-size: 1rem;
  color: #666666;
  text-align: left;
  margin-top: 2rem;
  padding-left: 2rem;
}

.content::v-deep {
  width: 95%;
  // margin-top: 2rem;
  line-height: 2.2rem;

  img {
    width: 100% !important;
    height: 100% !important;
  }

  // p>img,
  // section>img {
  //   width: 100% !important;
  //   height: auto !important;
  // }
}

.detail-style {
  .title {
    .topTxt {
      font-size: 1.6rem;
      color: #333333;
      font-weight: 540;
      margin-bottom: 0.8rem;
    }

    .lowTxt {
      font-size: 1rem;
      color: #666666;
      margin-bottom: 0.8rem;
    }
  }
}

@media (max-width: 768px) {
  .detail {
    .pt-5,
    .py-5 {
      padding: 1rem 0rem;
    }

    // .video {
    //   width: 45rem;
    //   height: 17rem;
    //   margin-top: 3rem;
    // }

    .right {
      background: white!important;
      flex: 2;
      display: flex;
    }

    .icon-wrap {
      display: none;
    }
  }
}
</style>